import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../formly/ga-formly.service';
import { ReportDataService } from '../../report-data.service';

import { IGenericUser } from '../../../../../type_definitions/datatypes';
import { GaEventService } from '../../../services/ga-event.service';

@Component({
  selector: 'assign-generic-user-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class AssignGenericUserActionComponent extends BaseReportActionsDialog implements OnInit {
  private genericUserField: IExtraFieldConfigurationObject;
  private noGenericUsersMessage: string = 'There are not available generic users to assign to the current selection';

  constructor(
    private formlyService: GaFormlyService,
    private reportDataService: ReportDataService,
    eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    // init model
    this.model = {
      userId: undefined,
      sendMailNotification: false
    };

    this.fields = this.createFields();
    this.fillFields();
  }

  private createFields():IExtraFieldConfigurationObject[] {
    return [
      this.genericUserField = this.formlyService.aSelect('userId', 'APP.USER_PROFILE.PERMISSIONS.GENERIC_USER')
        .isRequired()
        .withLabelProp('description')
        .withValueProp('id')
        .build(),

      this.formlyService.aCheckbox('sendMailNotification', 'Send mail notification')
        .build()
    ];
  }

  private fillFields():void {
    this.loading = true;
    this.updateButtonStatus();

    const genericUsersPromise:Promise<IGenericUser[]> = this.reportDataService.loadReportActionInfo(this.reportId, this.action.id, this.rowSelection)
      .then((actionInfoData) => {
        if (actionInfoData.info && !actionInfoData.info.length) {
          this.error = this.noGenericUsersMessage;
        }
        return actionInfoData.info;
      })
      .finally(() => {
        this.loading = false;
        this.updateButtonStatus();
      });

    this.formlyService.fillField(this.genericUserField, genericUsersPromise);
  }
}